import { render } from "./FooterBar.vue?vue&type=template&id=ab4b2fa8&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=ab4b2fa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4b2fa8"]])

export default __exports__